import * as Yup from 'yup';
import {
  MAX_FOUR_DECIMALS_REGEX,
  numberErrorMessage,
  requiredErrorMessage,
} from 'constants/constants';
import {
  MANUAL_SCOPE3_CONSTANTS,
  SCOPE3_EMISSION_UNIT,
} from 'constants/Scope3Constants/manualScope3Categories.constants';

const { UNIT_INVALID, EMISSIONS_NEGATIVE, EMISSIONS_DECIMALS } =
  MANUAL_SCOPE3_CONSTANTS.VALIDATION;

const isEmptyValue = (value: unknown) =>
  value === null || value === undefined || value === '';

export const manualEmissionValidationSchema = Yup.object().shape({
  unit: Yup.string()
    .nullable()
    .required(requiredErrorMessage)
    .oneOf(
      [SCOPE3_EMISSION_UNIT.KgCo2e, SCOPE3_EMISSION_UNIT.tCo2e],
      UNIT_INVALID
    ),
  emissions: Yup.mixed()
    .nullable()
    .required(requiredErrorMessage)
    .test('is-number', numberErrorMessage, value => {
      if (isEmptyValue(value)) return false;
      return !Number.isNaN(Number(value));
    })
    .test('min-zero', EMISSIONS_NEGATIVE, value => {
      if (isEmptyValue(value)) return false;
      return Number(value) >= 0;
    })
    .test('max-decimals', EMISSIONS_DECIMALS, value => {
      if (isEmptyValue(value)) return false;
      return MAX_FOUR_DECIMALS_REGEX.test(String(value));
    }),
});
